import styled from 'styled-components';

import { breakpoints, colors } from '@style-guide/config';

const ModalBody = styled.div`
  background-color: ${colors.white};
  max-height: 100vh;
  max-width: 100vw;
  min-height: 100vh;
  min-width: 100vw;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 25px;
  width: 100vw;

  -ms-overflow-style: none;  /* IE 10+ */
  overflow: -moz-scrollbars-none;  /* Firefox */

  &::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }

  @media (min-width: ${breakpoints.s}) {
    max-height: 90vh;
    max-width: 90vw;
    min-height: 60vh;
    min-width: 90vw;
  }

  @media (min-width: ${breakpoints.l}) {
    max-height: 90vh;
    max-width: ${breakpoints.l};
    min-height: 60vh;
    min-width: ${breakpoints.l};
  }
`;

ModalBody.displayName = 'ModalBody';

export default ModalBody;
